import { ValueFormatterParams } from 'ag-grid-community'

export const numberFormatter = (params: ValueFormatterParams): string => {
  if (params.value == null || params.value === '') return ''
  return params.value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
}

export const currencyFormatter = (params: ValueFormatterParams): string => {
  if (params.value == null || params.value === '') return ''
  return params.value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export const percentageFormatter = (params: ValueFormatterParams): string => {
  if (params.value == null || params.value === '') return ''
  return params.value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

// Shared pinned row formatters
export const pinnedRowCurrencyFormatter = (params: ValueFormatterParams): string => {
  const base = currencyFormatter(params)
  if (!base || !params.node?.rowPinned) return base
  const ctx = params.context as { dealCurrency?: string; isUSDSelected?: boolean } | undefined
  const currency = ctx?.isUSDSelected ? 'USD' : (ctx?.dealCurrency ?? '')
  return currency ? `${currency} ${base}` : base
}

export const pinnedRowPercentageFormatter = (params: ValueFormatterParams): string => {
  const base = percentageFormatter(params)
  return base && params.node?.rowPinned ? `${base}%` : base
}
